const purchasedTokenSkeletonStyle = {
    skeleton: `min-h-[150px] w-full bg-liveGameBackground animate-pulse rounded-[10px] mb-4`,
}

export { purchasedTokenSkeletonStyle }